

<template>
    <div class="shadow-lg rounded-lg bg-white relative">
        <div class="border-b p-4 relative">
            <p class="font-bold text-xl">{{ detail?.username }}</p>
            <p class="">{{ detail?.date_created }}</p>
            <p class="text-accent-color">{{  $t(`commentObjectType.${detail?.content_object?.type}`)  }}</p>
            <p class="text-white absolute top-0 right-0 px-3 py-1 rounded-bl" :class="state[detail.status].color">{{ state[detail.status]['label'][$i18n.locale] }}</p>
        </div>
        <div class="p-4">
            <div class="flex gap-3">
                <div >
                    <img class="size-20 aspect-square object-fill rounded" :src="detail?.content_object.thumbnail" alt="">
                </div>
                <div class="flex flex-col">
                    <p class="text-lg font-bold">{{ detail?.content_object.name }}</p>
                    <p class="font-bold text-accent-color">{{ detail?.content_object.price }} TMT</p>

                </div>
            </div>
            <p class="mt-2">
                {{ detail?.text }}

            </p>
        </div>
     

    </div>
</template>
<script>

export default {
    name: "CommentCard",
    components: {
    },
    props: {
      detail: {
          type: Object,
          default: {}
      },
      isMyReplies: {
        type: Boolean,
        default: false,
      }
    },
    data(){
        return {
            state: {
                0: {
                    label: {tk: 'Täze', ru: 'Новый'},
                    color: 'bg-yellow-500'
                },
                1: {
                    label: {tk: 'Neşir edildi', ru: 'Опубликовано'},
                    color: 'bg-green-500'
                },
                2: {
                    label: {tk: 'Gadagan edildi', ru: 'Запрещено'},
                    color: 'bg-red-500'
                },
            }
        }
    },
    methods: {

    }
}
</script>
<style scoped>

</style>